'use client';

import { useState } from 'react';

import { Box, Container } from '@mui/material';

import { CustomerElearning } from 'src/sections/landing/components/customer-elearning';
import { CenterRegisterForm } from 'src/sections/landing/components/center-register-form';
import { TestimonialElearning } from 'src/sections/landing/components/testimonial-elearning';

import { IntroFinancialManage } from '../components/intro-financial-mangement';
import { DetailFinancialManageFunction } from '../components/detail-financial-mangement-function';
import { StartWithCenterUpFinancialManage } from '../components/start-with-center-up-financial-mangement';

export const FinancialManageView = () => {
  const [openDemo, setOpenDemo] = useState<boolean>(false);
  return (
    <Box sx={{ overflowX: 'hidden', width: 1 }}>
      <Container>
        <IntroFinancialManage setOpenDemoForm={() => setOpenDemo(true)} />
        <CustomerElearning />
        <DetailFinancialManageFunction />
      </Container>
      <TestimonialElearning />
      <Container>
        <StartWithCenterUpFinancialManage setOpenDemoForm={() => setOpenDemo(true)} />
      </Container>
      {openDemo && <CenterRegisterForm open={openDemo} onClose={() => setOpenDemo(false)} />}
    </Box>
  );
};
